import { capturePostHogEvent } from "@/utils/posthog";

export type RequestProgramPosthogOpenEventSource =
  | "auto_timer"
  | "auto_scroll"
  | "auto_pageleave"
  | "top"
  | "before_program"
  | "after_program"
  | "side"
  | "search"
  | "banner"
  | "footer";

type Input = {
  step: "direct" | "open" | "close" | "success" | "open_address" | "close_address" | "success_address";
  source: RequestProgramPosthogOpenEventSource;
  travelId: number;
  versionId: number;
  departureId: number;
};
export const requestProgramEvent = ({ step, source, travelId, versionId, departureId }: Input) => {
  capturePostHogEvent("request_program", {
    program_request_step: step,
    program_request_source: source,
    travel_id: travelId,
    version_id: versionId,
    departure_id: departureId,
  });
};
